import { collection, onSnapshot, query } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { firestore } from "../firebase";
import { CustomerCluster } from "../types/CustomerCluster";

export function useCustomerClusters(projectId: string | null) {
  const [clusters, setClusters] = useState<CustomerCluster[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!projectId) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const q = query(
      collection(firestore, "projects", projectId, "customer-clusters"),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data() as CustomerCluster);
        setClusters(data);
        setIsLoading(false);
      },
      (err) => {
        console.error("Failed to load customer clusters:", err);
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, [projectId]);

  return useMemo(() => ({ clusters, isLoading }), [clusters, isLoading]);
}
